import type { Flights, Fare } from "@b2bportal/air-shopping-api";
import type { ISelectedTrip, IFlightListData } from "@b2bportal/core-types";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const getDurationFromMins = (mins: number) => {
  const durationObj = dayjs.duration(mins, "minutes");
  return [
    { value: durationObj.days(), key: "days" },
    { value: durationObj.hours(), key: "hours" },
    { value: durationObj.minutes(), key: "minutes" },
  ];
};

export const getReturnFlights = (
  flights: Flights,
  returnTripIds: string[],
  selectedTrip: ISelectedTrip
) => {
  const selectedOutgoingFare = selectedTrip.outgoingFareId
    ? flights.fares[selectedTrip.outgoingFareId]
    : null;
  const selectedOutgoingFareSlice = selectedOutgoingFare
    ? flights.fareSlices[selectedOutgoingFare.outbound]
    : null;

  const selectedOutgoingFareSliceId = selectedOutgoingFareSlice?.id;

  return returnTripIds.reduce(
    (returnFlightList: IFlightListData<Fare>[], tripId: string) => {
      const trip = flights.trips[tripId];
      const returnSliceId = flights.trips[tripId].return || "";

      const tripFares = trip.fares.map(
        (fareId: string) => flights.fares[fareId]
      );

      // Logic for filtering return flights
      const getFilteredFares = () => {
        return tripFares.filter((tripFare) => {
          if (!tripFare.return) return true;

          const returnFareSlice = flights.fareSlices[tripFare.return];
          const outgoingFareSlice = flights.fareSlices[tripFare.outbound];

          // if the fare has the selected outgoing FARE SLICE, the return fare slice must be valid (even though the fare classes are different - Hacker fare)
          if (
            selectedOutgoingFareSliceId &&
            tripFare.outbound === selectedOutgoingFareSliceId
          ) {
            return true;
            // even if the fare doesn't have the selected outgoing fare slice, we will show the same or higher fare classes (upsell)
            // as long as the matching outbound fare is higher or equal to the selected outboound
          } else if (
            selectedTrip.outgoingFareRating !== null &&
            selectedTrip.outgoingFareRating !== undefined
          ) {
            return (
              returnFareSlice.fareShelf.value >=
                selectedTrip.outgoingFareRating &&
              outgoingFareSlice.fareShelf.value >=
                selectedTrip.outgoingFareRating
            );
          } else {
            return false;
          }
        });
      };

      const filteredTripFares = getFilteredFares();

      if (filteredTripFares.length > 0) {
        returnFlightList.push({
          sliceId: returnSliceId,
          fares: filteredTripFares,
        });
      }

      return returnFlightList;
    },
    []
  );
};
